// extracted by mini-css-extract-plugin
export default {"ReadOnlyTooltipContent":"ReadOnlyTooltipContent_ReadOnlyTooltipContent__OH9u5","title":"ReadOnlyTooltipContent_title__N63sS"};